var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-brand-primary",attrs:{"id":"SliderQuestion"}},_vm._l((_vm.question.sliders),function(item,i){return _c('Slider',{key:i,attrs:{"question":item,"updateAnswer":_vm.updateAnswer,"index":i,"defaultOption":_vm.answer[item.slider_text]}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }